<template>
    <tr class="business-hours-list-item" :class="{disabled: isReadOnly}">
      <td>
        <toggle v-model="form.isActiveDay"
                @input="editDay"></toggle>
      </td>

      <td>
        {{ dayOfWeek }}
      </td>

      <td>
        <app-hour-picker v-model="form.openingTime"
                        class="hour"
                        :readonly="isReadOnly"
                        @input="setTime('opening', $event)"></app-hour-picker>
      </td>

      <td>
        <app-hour-picker v-model="form.closingTime"
                        class="hour"
                        :readonly="isReadOnly"
                        @input="setTime('closing', $event)"></app-hour-picker>
      </td>

      <td class="checkbox-wrapper">        
        <v-checkbox v-model="form.limitCaptiveToPeriod"
               class="checkbox"
               :disabled="isReadOnly"
               @change="setHasBeenEdited"></v-checkbox>
      </td>

      <td>
        <app-button v-if="hasBeenEdited"
                  class="extra-field-create-activator btn btn-primary_bottom"
                  :label="$t('message.generics.message.save')"
                  flat
                  underline
                  primary
                  @click="editDay">

        </app-button>
      </td>
    </tr>
  </template>

  <script>
  import Toggle from "@components/Toggle";
  import AppHourPicker from "@components/HourPicker";
  import AppButton from "@components/generic/button/Button";
import EventBus from "../../../../../packages/event-bus";

  export default {
    components: {
        Toggle,
        AppHourPicker,
        AppButton
    },

    data() {
      return {
        form: {
            dayOfWeek: undefined,
            isActiveDay: undefined,
            openingTime: undefined,
            closingTime: undefined,
            limitCaptiveToPeriod: undefined
        },
        hasBeenEdited: false
      };
    },

    props: {
      item: {
        type: Object,
        required: true,
      },
    },

    computed: {
      dayOfWeek() {
        return {
            ["SUNDAY"]: this.$t('message.statistics.message.sunday'),
            ["MONDAY"]: this.$t('message.statistics.message.monday'),
            ["TUESDAY"]: this.$t('message.statistics.message.tuesday'),
            ["WEDNESDAY"]: this.$t('message.statistics.message.wednesday'),
            ["THURSDAY"]: this.$t('message.statistics.message.thursday'),
            ["FRIDAY"]: this.$t('message.statistics.message.friday'),
            ["SATURDAY"]: this.$t('message.statistics.message.saturday')
        }[this.item.dayOfWeek]
      },
      isReadOnly() {
        return this.form.isActiveDay ? false : true
      }
    },

    methods: {
      emitReload() {
        this.$emit("reload");
      },
      setInitialData() {
        this.form = {
            dayOfWeek: this.item.dayOfWeek,
            isActiveDay: this.item.isActiveDay,
            openingTime: this.item.openingTime,
            closingTime: this.item.closingTime,
            limitCaptiveToPeriod: this.item.limitCaptiveToPeriod
        }

      },
      async editDay() {
        try {
          const response = this.validateTime()
          if(!response.valid) {
            return EventBus.$emit("show-message", {
                type: "ERROR",
                message: response.message,
            });
          }
          await this.$api.core.businessHours.edit({
              dayOfWeek: this.form.dayOfWeek,
              isActiveDay: this.form.isActiveDay,
              openingTime: this.form.openingTime,
              closingTime: this.form.closingTime,
              limitCaptiveToPeriod: this.form.limitCaptiveToPeriod,
          })
          this.hasBeenEdited = false
          return EventBus.$emit("show-message", {
            type: "SUCCESS",
            message: this.$t('message.successMessages.message.dayEdited'),
          });
        } catch (error) {
            console.log(error)
        }
      },
      setTime(key, value) {
        key === "opening" ? this.form.openingTime = value : this.form.closingTime = value;
        this.setHasBeenEdited()
      },
      setHasBeenEdited() {
        this.hasBeenEdited = true
      },
      resetData() {
        this.form.openingTime = this.item.openingTime;
        this.form.closingTime = this.item.closingTime;
        this.form.limitCaptiveToPeriod = this.item.limitCaptiveToPeriod;
        this.hasBeenEdited = false
      },
      isValidHour(hour) {
        return /^([0-1]?[0-9]|2[0-3]):[0-5][0-9]$/.test(hour)
      },
      validateTime() {
        try {
          if(!this.isValidHour(this.form.openingTime) || !this.isValidHour(this.form.closingTime)) throw this.$t('message.errorMessages.message.invalidTime')
          return {
            valid: true
          }
        } catch (error) {
          this.resetData()
          return {
            valid: false,
            message: error
          }
        }
      },
    },

    mounted() {
      this.setInitialData()
    }
  };
  </script>

  <style lang="scss" scoped>
    .disabled {
      background-color: #EEEEEE;
    }
    .v-text-field {
        padding-top: 5px !important;
    }

    .hour {
        width: 57px;
    }
    .checkbox-wrapper {
        display: flex;
        justify-content: center;
        align-items: center;        

        .checkbox {
          flex: none;
          padding-top: 20px;
        }
    }


  </style>
